import { useMasterList } from '../../common/useMasterList';
import { useExportJob } from '../../../../hooks/useExportJob';
import { relationApi } from '../api/relationApi';

export const useRelationListScreen = () => {
  const master = useMasterList({
    entityName: 'Relation',
    apiClient: relationApi,
  });
  
  const { triggerExport, isExporting } = useExportJob({
    module: 'relation',
    fileFormat: 'XLSX',
  });

  const handleToolSelect = (toolKey) => {
    if (toolKey === 'download' || toolKey === 'export_excel') {
      triggerExport({
        viewMode: master.state.viewMode,
        searchText: master.state.searchText,
      });
    }
  };

  return {
    ...master,
    state: {
      ...master.state,
      isExporting,
    },
    actions: {
      ...master.actions,
      handleToolSelect,
    },
  };
};
